import { render } from "./ShoppingList.vue?vue&type=template&id=4733d158"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__